import styled from '@emotion/styled';
import { ProjectState as ProjectStateType } from '@kaizenplatform/hugot-entity';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../../../theme';
import { SPACING_UNIT } from '../../constant/spacing';

// ProjectState and BadgeColor adaptation
const badgeColor = {
  draft: {
    background: '#FCB100',
    text: theme.palette.text,
  },
  submitted: {
    background: '#0070C9',
    text: '#FFFFFF',
  },
  assigned: {
    background: '#0070C9',
    text: '#FFFFFF',
  },
  editing: {
    background: '#00A46E',
    text: '#FFFFFF',
  },
  canceled: {
    background: theme.palette.grey['600'],
    text: '#FFFFFF',
  },
  finalized: {
    background: theme.palette.grey['600'],
    text: '#FFFFFF',
  },
};

interface Props {
  projectState: ProjectStateType | 'editing';
  className?: string;
}

const ProjectStateBadge = ({ projectState }: ClassAttributes<HTMLElement> & Props) => (
  <Root projectState={projectState}>
    <Typography component="span">
      <FormattedMessage id={`project_state.${projectState}`} />
    </Typography>
  </Root>
);

const Root = styled('span')<Props>(({ projectState }) => ({
  display: 'inline-block',
  width: 92,
  borderRadius: 2,
  padding: `${SPACING_UNIT / 4}px 0`,
  lineHeight: 1,
  backgroundColor: badgeColor[projectState].background as string,
  textAlign: 'center',
  '& > *': {
    fontSize: '12px',
    color: badgeColor[projectState].text,
    whiteSpace: 'nowrap',
  } as any,
  '&:nth-of-type(2)': {
    marginTop: 8,
  },
}));

export default ProjectStateBadge;
